import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df4c7a40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mesCentresDinterets",
  class: "flex w-screen"
}
const _hoisted_2 = { class: "titleSection ml-10" }
const _hoisted_3 = { class: "text-xl my-auto ml-32" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-5 h-5 bg-green-600 rounded-full mr-3" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-5 h-5 bg-green-600 rounded-full mr-3" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-5 h-1 bg-green-600 mr-3 ml-10" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-5 h-1 bg-green-600 mr-3 ml-10" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-5 h-1 bg-green-600 mr-3 ml-10" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-5 h-1 bg-green-600 mr-3 ml-10" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-5 h-5 bg-green-600 rounded-full mr-3" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-5 h-5 bg-green-600 rounded-full mr-3" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-5 h-5 bg-green-600 rounded-full mr-3" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('header.sommaire.5')), 1),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _hoisted_4,
        _createTextVNode(_toDisplayString(_ctx.$t('mesCentresDinterets.photographie')), 1)
      ]),
      _createElementVNode("li", null, [
        _hoisted_5,
        _createTextVNode(_toDisplayString(_ctx.$t('mesCentresDinterets.nouvelleTechnologie.principal')), 1)
      ]),
      _createElementVNode("li", null, [
        _hoisted_6,
        _createTextVNode(_toDisplayString(_ctx.$t('mesCentresDinterets.nouvelleTechnologie.stream')), 1)
      ]),
      _createElementVNode("li", null, [
        _hoisted_7,
        _createTextVNode(_toDisplayString(_ctx.$t('mesCentresDinterets.nouvelleTechnologie.web')), 1)
      ]),
      _createElementVNode("li", null, [
        _hoisted_8,
        _createTextVNode(_toDisplayString(_ctx.$t('mesCentresDinterets.nouvelleTechnologie.informatique')), 1)
      ]),
      _createElementVNode("li", null, [
        _hoisted_9,
        _createTextVNode(_toDisplayString(_ctx.$t('mesCentresDinterets.nouvelleTechnologie.connecter')), 1)
      ]),
      _createElementVNode("li", null, [
        _hoisted_10,
        _createTextVNode(_toDisplayString(_ctx.$t('mesCentresDinterets.jeuxVideo')), 1)
      ]),
      _createElementVNode("li", null, [
        _hoisted_11,
        _createTextVNode(_toDisplayString(_ctx.$t('mesCentresDinterets.tir')), 1)
      ]),
      _createElementVNode("li", null, [
        _hoisted_12,
        _createTextVNode(_toDisplayString(_ctx.$t('mesCentresDinterets.piano')), 1)
      ])
    ])
  ]))
}